import { render } from "./CrudDoctors.vue?vue&type=template&id=5e4b01fe&scoped=true"
import script from "./CrudDoctors.vue?vue&type=script&lang=js"
export * from "./CrudDoctors.vue?vue&type=script&lang=js"

import "./CrudDoctors.vue?vue&type=style&index=0&id=5e4b01fe&lang=css"
import "./CrudDoctors.vue?vue&type=style&index=1&id=5e4b01fe&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4b01fe"]])

export default __exports__